import { render, staticRenderFns } from "./NotEditor.vue?vue&type=template&id=966169f4"
import script from "./NotEditor.vue?vue&type=script&lang=ts"
export * from "./NotEditor.vue?vue&type=script&lang=ts"
import style0 from "./NotEditor.vue?vue&type=style&index=0&id=966169f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports